import type { SearchArticleMeta } from "@serophin/nottldr-shared";
import { useRef } from "preact/hooks";
import type { CurrentArticle } from "../AudioPlayerContext";

export type Playlist = {
  setPlaylist: (metas: SearchArticleMeta[]) => void;
  /** The article `offset` places after (or, negative, before) the current one, or null at the ends and when the current one is not in the list. */
  neighbour: (current: CurrentArticle | null, offset: number) => SearchArticleMeta | null;
};

/** The articles on screen, in order. A ref rather than state: nothing renders from it. */
export const usePlaylist = (): Playlist => {
  const metas = useRef<SearchArticleMeta[]>([]);
  return {
    setPlaylist: (next) => {
      metas.current = next;
    },
    neighbour: (current, offset) => {
      const index = current ? metas.current.findIndex((meta) => meta.authorAlias === current.authorAlias && meta.id === current.articleId) : -1;
      return index < 0 ? null : (metas.current[index + offset] ?? null);
    },
  };
};

/** Brings the card of the track that just started into view, as the list moves on by itself. */
export const scrollToCard = (meta: SearchArticleMeta): void => {
  const card = document.getElementById(`article-card-${meta.authorAlias}.${meta.id}`);
  if (card) {
    window.scrollTo({ top: card.getBoundingClientRect().top + window.scrollY - 100, behavior: "smooth" });
  }
};
